import { useWorkspaceEntitlements } from './useEntitlements';

/**
 * True when the active workspace runs on the shared credential rail (the basic
 * plan). Basic prototypes live under the platform's dedicated GitHub org, which
 * the customer cannot access — so GitHub-facing UI (repo/PR links, merge
 * controls) is a dead end and is hidden for them. Defaults to `false` while the
 * entitlements load, so nothing flickers away for pro workspaces.
 */
export function useIsBasicWorkspace(): boolean {
  return useWorkspaceEntitlements().data?.credentialMode === 'shared';
}
